import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";

export const FinalCTA = () => (
  <section data-testid="final-cta-section" className="px-6 pb-24 md:px-12 md:pb-32">
    <Reveal>
      <div className="relative mx-auto max-w-7xl overflow-hidden rounded-[2.5rem] bg-[#0F4D3F] px-8 py-20 md:px-16 md:py-28">
        <div aria-hidden className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full border-[28px] border-[#C6F04A]/15" />
        <div aria-hidden className="pointer-events-none absolute -bottom-32 -left-20 h-80 w-80 rounded-full bg-[#C6F04A]/10" />

        <div className="relative max-w-2xl">
          <h2 className="text-4xl font-medium tracking-tight text-[#F3EBD7] md:text-6xl" data-testid="final-cta-title">
            Empieza por lo que necesitas hoy.
          </h2>
          <p className="mt-6 text-base font-light leading-relaxed text-[#F3EBD7]/75 md:text-lg" data-testid="final-cta-text">
            Elige una solución TUPU y construye una operación más simple, ordenada y controlada.
          </p>
          <a
            href="#productos"
            data-testid="final-cta-button"
            className="mt-10 inline-flex items-center gap-2.5 rounded-full bg-[#C6F04A] px-8 py-4 text-sm font-bold text-[#1F3D35] transition-[background-color,transform] duration-200 hover:bg-[#d4f76b] active:scale-[0.98]"
          >
            Ver soluciones
            <ArrowRight size={17} />
          </a>
        </div>
      </div>
    </Reveal>
  </section>
);
